export const DateAccountingTypePath = "##DateAccountingType##";
export const DateReceivedTypePath = "##DateReceivedType##";
export const DraftIdsPath = "##DraftIds##";

export const NoVatItem = "NoVatItem";